import { Routes, Route } from "react-router-dom"
import Login from "../components/login/Login"
import SignUp from "../components/signup/SignUp"
import Register from "../components/signup/Register"
import ForgotPassword from "../components/login/ForgotPassword"
import ForgotPasswordLink from "../components/changePassword/ForgotPasswordLink"

const UnAuthenticatedRoutes = () => {
    return (
    <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/front-page" element={<SignUp />} />
        <Route path="/candidate-register" element={<Register />} />
        <Route path="/forget-password" element={<ForgotPassword />} />
        <Route path="/forgetPassword-screen" element={<ForgotPasswordLink />} />
    </Routes>
    )
}

export default UnAuthenticatedRoutes